<template>
  <el-dialog
    :title="dialogType === 'edit' ? '编辑' : '添加'"
    :before-close="closeDialog"
    width="60%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="dataForm"
      :model="tempData"
      label-width="120px"
      :rules="rules"
    >
      <el-form-item label="链接应用说明" prop="description">
        <el-input placeholder="*输入参考：官网跳转京东商城" v-model="tempData.description"></el-input>
      </el-form-item>
      <el-form-item label="中转地址" prop="urlCode">
        <el-input placeholder="*输入参考：GWTJD" v-model="tempData.urlCode" :disabled="dialogType !== 'create'"></el-input>
      </el-form-item>
      <el-form-item label="跳转后地址" prop="redirectUrl">
        <el-input placeholder="*输入参考：https://mall.jd.com/index-11473697.html" v-model="tempData.redirectUrl"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="saveData()">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { insertMonitorLink, defaultMonitorLinkData, updateMonitorLink } from '@/api/monitor'
export default {
  props: ['dialogType', 'dialogVisible', 'tempData'],
  data() {
    return {
      rules: {
        description: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        urlCode: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        redirectUrl: [{ required: true, message: '正文不能为空', trigger: 'blur' }]
      },
      tempDataTemp: {}
    }
  },
  mounted() {
    this.tempDataTemp = this.tempData
  },
  methods: {
    async save() {
      this.tempDataTemp.updateTime = new Date()
      await insertMonitorLink(this.tempData).then(() => {
        this.closeDialog()
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
        this.$emit('save-data', '')
      })
    },
    async upadate() {
      this.tempDataTemp.updateTime = new Date()
      await updateMonitorLink(this.tempData).then(() => {
        this.closeDialog()
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        })
        this.$emit('save-data', '')
      })
    },
    saveData() {
      if (this.dialogType === 'create') {
        this.save()
      } else {
        this.upadate()
      }
    },
    closeDialog() {
      this.$emit('close-dialog', true)
    }
  }
}
</script>
<style scoped>
.edit-warp {
  border: 1px solid #c0c4cc;
}
</style>
